import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { UserRoles, RestaurantNotificationEventType } from 'types';
import {
	restaurantNotificationEvents,
	availablePushScheduleForClientManager,
	availablePushScheduleForRestaurantManager,
} from 'appConstants';
import { useRoleAccess } from 'hooks/useRoleAccess';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IPushTypeSelect {
	setPushType: (value: RestaurantNotificationEventType | null) => void;
}

const PushTypeSelect: React.FC<IPushTypeSelect> = ({ setPushType }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');
	const hasFullAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasClientManagerAccess = useRoleAccess([UserRoles.CLIENT_MANAGER, UserRoles.GROUP_MANAGER]);
	const hasRestaurantManagerAccess = useRoleAccess([UserRoles.RESTAURANT_MANAGER]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectPushType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		if (hasFullAccess) {
			return restaurantNotificationEvents.map((el) => ({
				id: el,
				name: tForm(el),
			}));
		}
		if (hasClientManagerAccess) {
			return availablePushScheduleForClientManager.map((el) => ({
				id: el,
				name: tForm(el),
			}));
		}
		if (hasRestaurantManagerAccess) {
			return availablePushScheduleForRestaurantManager.map((el) => ({
				id: el,
				name: tForm(el),
			}));
		}
		return [];
	}, [tForm, hasFullAccess, hasClientManagerAccess, hasRestaurantManagerAccess]);

	return (
		<FormSelect
			testId="PushTypeSelect"
			name="pushType"
			label="pushTypeLabel"
			options={mappedOptions}
			onChange={setPushType}
			validationRules={validationRules}
			withSearch={true}
		/>
	);
};

export default React.memo(PushTypeSelect);
